"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationsOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.48 3c-3.63 0-6 1.58-7 4.52a8.43 8.43 0 011.71 1.37C17.73 6.29 19.44 5 22.48 5c3.76 0 5.57 1.87 5.57 5.9 0 4.41-4 9-5.57 10.68a29.49 29.49 0 01-2.59-3.17 14.42 14.42 0 01-.55 2.61 26.69 26.69 0 002.46 2.71l.68.64.69-.64c.27-.23 6.83-6.39 6.83-12.8C30 5.83 27.32 3 22.48 3zM9.5 9C4.66 9 2 11.84 2 16.94c0 6.41 6.54 12.56 6.82 12.82l.68.64.68-.64c.28-.26 6.82-6.41 6.82-12.82C17 11.84 14.34 9 9.5 9zm0 18.58C7.89 25.92 4 21.36 4 16.94 4 12.91 5.75 11 9.5 11s5.5 1.91 5.5 5.94c0 4.41-3.89 8.98-5.5 10.67z" }),
        React.createElement("path", { d: "M9.5 13.48A3.5 3.5 0 1013 17a3.5 3.5 0 00-3.5-3.52zm0 5A1.5 1.5 0 1111 17a1.5 1.5 0 01-1.5 1.48zM22.5 14.48A3.5 3.5 0 1019 11a3.5 3.5 0 003.5 3.48zm0-5A1.5 1.5 0 1121 11a1.5 1.5 0 011.5-1.52z" })));
}
exports.default = SvgLocationsOutline;
//# sourceMappingURL=LocationsOutline.js.map